import React from 'react';

import { AuthContext } from '@/providers/auth/AuthContext';

export function useAuth() {
  return React.useContext(AuthContext);
}
